import { UpdateFrequency } from "./utils";

export function isUpdatable(
  key: string, state: any, updatabilityInfo: any
) {
  const updateFrequency = updatabilityInfo[key]?.frequency || UpdateFrequency.Updatable;
  const condition = () => updatabilityInfo[key]?.condition(state);
  const isNotSet = () => !state[key];

  return (
    updateFrequency === UpdateFrequency.Updatable ||
    updateFrequency === UpdateFrequency.ConditionallyUpdatable && condition() ||
    updateFrequency === UpdateFrequency.NotUpdatable && isNotSet()
  );
}

export function getNotUpdatableFields(
  input: any, updatabilityInfo: any
) : Array<string> {
  return Object.keys(input).filter(key => {
    const notUpdatable = !updatabilityInfo[key];
    const fullyUpdatable = updatabilityInfo[key] === true;
    const childNotUpdatableFields = !fullyUpdatable && typeof input[key] === 'object' && typeof updatabilityInfo[key] === 'object' && getNotUpdatableFields(
      input[key],
      updatabilityInfo[key]
    ) || [];

    return notUpdatable || childNotUpdatableFields.length > 0;
  });
}